(function($) {
    var primaryNavigation = $('#genesis-navigation-collapse');
    var siteHeader = $('#siteHeader');
    var siteOverlay = $('#siteOverlay');
    var siteHeaderHeight = siteHeader.outerHeight();
    var siteMain = $('#siteMain');

	$('#menu-primary-menu > li').each(function(){
		if ($(this).hasClass('menu-btn')) {
			$(this).children('a').addClass('btn btn-primary btn-header');
		} else {
			$(this).children('a').addClass('nav-link');
		}
		if ($(this).hasClass('menu-item-has-children')) {
			$(this).addClass('dropdown');
			$(this).children('a')
				.attr('data-bs-toggle','dropdown')
				.attr('aria-expanded','false')
		}
	});
	$('#menu-primary-menu > li > .sub-menu').each(function(){
		$(this).addClass('dropdown-menu').attr('aria-labelledby', $(this).closest('li').attr('id'));
		$(this).find('li').removeClass('menu-item');
		if ($(this).find('.sub-menu').length) {
			$(this).addClass('dm-large');
			$(this).children('li').addClass('dm-item');
		} else {
			$(this).addClass('dm-small');
			$(this).closest('li').addClass('position-relative');
		}
	});
	$('.dm-item').each(function(){
		$(this).children('a').addClass('dm-title');
		$(this).children('.sub-menu').addClass('dm-sub');
	});
	// only highlight current section 
	$('.dm-sub').each(function(){
		$(this).find('a').each(function(){
			let link = $(this).attr('href');
			if( link.includes('#') ) {
				let target = '#' + link.split('#')[1];
				if( window.location.hash === target ){
					$(this).closest('.current-menu-ancestor').removeClass('current-menu-item'); // column heading
					$(this).closest('.current-menu-ancestor').find('li').removeClass('current-menu-item'); // siblings
					$(this).closest('li').addClass('current-menu-item'); // self
				}
			}
		});
	});
	// change current page when chosing other on-page links
	$('.dm-sub a').on('click', function(){
		let link = $(this).attr('href');
		if( link.includes('#') ) {
			$(this).closest('.dm-sub').find('li').removeClass('current-menu-item');
			$(this).closest('li').addClass('current-menu-item');
		}
	});

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            siteOverlay.removeClass('show');
            siteHeader.removeClass('nav-open');
            $this.addClass('collapsed');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            siteOverlay.addClass('show');
            siteHeader.addClass('nav-open');
            $this.removeClass('collapsed');
        }
    });

    // close navigation when clicking on overlay (mobile)
    siteOverlay.on('click', function() {
        $(this).removeClass('show');
        $('body').removeClass('no-scroll');
        $('#navbarToggle').addClass('collapsed');
        primaryNavigation.removeClass('is-expanded');
        siteHeader.removeClass('nav-open');
    });

    // sub dropdown (mobile)
    if (window.innerWidth <= 992) { 
        $('.dm-title').each(function() {
            $this = $(this);

            $this.on('click', function(e) {
                e.stopPropagation();
                $this = $(this);
            
                if($this.hasClass('show')) {
                    $this
                        .removeClass('show')
                        .closest('.dm-item')
                        .find('.dm-sub')
                        .removeClass('show')
                } else {
                    $this
                        .addClass('show')
                        .closest('.dm-item')
                        .find('.dm-sub')
                        .addClass('show')
                }
            });
        });

        $('.navbar-primary .nav-link').on('click', function(e) {
            $('.dm-title').removeClass('show');
            $('.dm-sub').removeClass('show');
        });
    }

}(jQuery));


// navbar toggle
$('.jsTabsToggle').each(function() {
    const $this = $(this);
    const $toggleContainer = $this.closest('.nav-tabs-container').find('.nav');
	const $navItems = $toggleContainer.find('.nav-item');

    $(this).on('click', function() {

        if ($this.hasClass('show')) {
            $this.removeClass('show');
            $toggleContainer.removeClass('show')
        } else {
            $this.addClass('show');
            $toggleContainer.addClass('show')
        }
    });

	$navItems.on('click', function(e){
		e.preventDefault();
		$toggleContainer.removeClass('show');
		$this.removeClass('show');
		$this.find('.text').text($(this).text());
	});
	
});